import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class DataEnrichmentService {
  baseHref = `${environment.apiUrl}/data-enrichment`;

  constructor(private http: HttpClient) {}

  getTotalTaskViewCount(taskId: number): Observable<any> {
    const url = `${this.baseHref}/task-view-count/${taskId}`;
    return this.http.get<any>(url);
  }
}
